module.exports = __webpack_public_path__ + "img/self-ship.445ad12d.png";